import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter } from "@angular/core";
import * as XLSX from 'xlsx';
import { DataService } from '../../../shared/services/data.service';
import { InProductsService } from "../../../shared/services/inventory/in-products.service";
import { InToolsService } from '../../../shared/services/inventory/in-tools.service';

@Component({
  selector: "app-import",
  templateUrl: "./import.component.html",
  styleUrls: ["./import.component.css"]
})
export class ImportComponent {

  loading: boolean = false;
  reader: any;
  ItemList: any = [];
  @Output() onImportComplete: EventEmitter<any> = new EventEmitter<any>();
  ImportStylecode: boolean = false;
  ImportItesm: boolean = false;
  @ViewChild("ImptItem") ImptItem: ElementRef;
  @ViewChild("ImptStyle") ImptStyle: ElementRef;
  @ViewChild("ImptPromotion") ImptPromotion: ElementRef;
  PromotionImport: boolean = false;

  constructor(private ds: DataService, private pds: InProductsService, private ts: InToolsService) { }
  ngOnInit() {
    var sc = (this.ds.Settings.ImportStylecode)
    this.ImportStylecode = sc.toLowerCase() == 'true'

    var im = (this.ds.Settings.ImportItesm)
    this.ImportItesm = im.toLowerCase() == 'true'

    var ip = (this.ds.Settings.PromotionImport)
    this.PromotionImport = ip.toLowerCase() == 'true'
  }

  ImportItem(e: any) {
    this.loading = true;
    var files = e.target.files, file;
    if (!files || files.length == 0) return;
    file = files[0];
    this.reader = new FileReader();
    var list: any = []
    this.reader.onload = function (el: any) {
      var binary = "";
      var bytes = new Uint8Array(el.target.result);
      var length = bytes.byteLength;
      for (var i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      var oFile = XLSX.read(binary, { type: 'binary', cellDates: true, cellStyles: true });
      var first_sheet_name = oFile.SheetNames[0];
      var worksheet = oFile.Sheets[first_sheet_name];
      var data = XLSX.utils.sheet_to_json(worksheet, {
        raw: true
      });
      var ip: any = data
      for (let i of ip) {
        list.push({ Barcode: i.Barcode, Qty: i.Qty, CostPrice: i.CostPrice, SellingPrice: i.SellingPrice });
      }
    };
    this.reader.onloadend = (e) => {
      var importlist: any = []
      for (let i of list) {
        importlist.push({
          Barcode: i.Barcode,
          Qty: i.Qty,
          Cost: i.CostPrice,
          Sellingprice: i.SellingPrice
        })
      }
      this.ItemList = [];
      var IdItemType: any = {
        Id: this.ds.Settings.ItemTypeId,
        Barcode: "",
        SellingPrice: this.ds.Settings.SellingPriceLevelId,
        Branch: this.ds.Settings.BranchId,
        Location: this.ds.Settings.LocationId,
        excelitems: importlist
      }
      this.pds.ImportitemsfromExcel(IdItemType).subscribe(res => {
        if (res.Success) {
          for (let i of res.data) {
            this.ItemList.push(i)
          }
          this.onImportComplete.emit({
            r: Math.random(),
            data: this.ItemList,
          });
          this.loading = true;
          var a: any = document.getElementById("ImptItem")
          a.value = ""
          this.loading = false
        }
        else {
          alert(res.error.UserMsg)
          this.loading = false;
        }
      });
    }
    this.loading = false
    this.reader.readAsArrayBuffer(file);
  }

  ImportStyleCode(e: any) {
    this.loading = true;
    var files = e.target.files;
    if (!files || files.length == 0) return;
    var file = files[0];
    //var extention=file.name.split('?')[0].split('.').pop();
    if (file.type == "text/csv") {
      this.reader = new FileReader();
      this.reader.readAsText(file);
      this.reader.onload = (event: any) => {
        var csv = event.target.result;
        var data = {
          StyleCodeItems: csv,
          SellingPriceLevel: this.ds.Settings.SellingPriceLevelId,
          BranchId: this.ds.Settings.BranchId,
          IsCsv: true
        }
        this.ItemList = [];
        this.ts.Get_StyleCodeImportData(data).subscribe(res => {
          if (res.Success) {
            for (let i of res.data) {
              this.ItemList.push(i)
            }
            this.onImportComplete.emit({
              r: Math.random(),
              data: this.ItemList,
            });
            this.loading = true;
            var a: any = document.getElementById("ImptStyle");
            a.value = "";
            this.loading = false;
          }
          else {
            alert(res.error.UsrMsg);
            this.loading = false;
          }
        });
      }
    }
    else if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      var csvFile = ""
      var files = e.target.files, file;
      if (!files || files.length == 0) return;
      file = files[0];
      this.reader = new FileReader();
      this.reader.onload = function (el: any) {
        var binary = "";
        var bytes = new Uint8Array(el.target.result);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        var oFile = XLSX.read(binary, { type: 'binary', cellDates: true, cellStyles: true });
        var first_sheet_name = oFile.SheetNames[0];
        var worksheet = oFile.Sheets[first_sheet_name];
        csvFile = XLSX.utils.sheet_to_csv(worksheet, {});
      };
      this.reader.onloadend = (e) => {
        var data = {
          StyleCodeItems: csvFile,
          SellingPriceLevel: this.ds.Settings.SellingPriceLevelId,
          BranchId: this.ds.Settings.BranchId,
          IsCsv: false
        }
        this.ItemList = [];
        this.ts.Get_StyleCodeImportData(data).subscribe(res => {
          if (res.Success) {
            for (let i of res.data) {
              this.ItemList.push(i)
            }
            this.onImportComplete.emit({
              r: Math.random(),
              data: this.ItemList,
            });
            this.loading = true;
            var a: any = document.getElementById("ImptStyle");
            a.value = "";
            this.loading = false;
          }
          else {
            alert(res.error.UsrMsg);
            this.loading = false;
          }
        });
      }
      this.loading = false;
      this.reader.readAsArrayBuffer(file);
    }
    else {
      alert("Please check file format!!");
      this.loading = false;
    }
    this.loading = false;
  }

  FileUploaderChange(value) {
    if (value == 1) {
      this.ImptItem.nativeElement.value = "";
      this.ImptItem.nativeElement.click();
    }
    else if (value == 2) {
      this.ImptStyle.nativeElement.value = "";
      this.ImptStyle.nativeElement.click();
    }
    else if (value == 3) {
      this.ImptPromotion.nativeElement.value = "";
      this.ImptPromotion.nativeElement.click();
    }
    else {
      this.ImptItem.nativeElement.value = "";
      this.ImptStyle.nativeElement.value = "";
    }
  }

  ImportPromotion(e: any) {
    this.loading = true;
    var files = e.target.files, file;
    if (!files || files.length == 0) return;
    file = files[0];
    this.reader = new FileReader();
    var list: any = []
    this.reader.onload = function (el: any) {
      var binary = "";
      var bytes = new Uint8Array(el.target.result);
      var length = bytes.byteLength;
      for (var i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      var oFile = XLSX.read(binary, { type: 'binary', cellDates: true, cellStyles: true });
      var first_sheet_name = oFile.SheetNames[0];
      var worksheet = oFile.Sheets[first_sheet_name];
      var data = XLSX.utils.sheet_to_json(worksheet, {
        raw: true
      });
      var ip: any = data
      for (let i of ip) {
        list.push({ Barcode: i.Barcode, NewPrice: i.NewPrice });
      }
    };
    this.reader.onloadend = (e) => {
      var importlist: any = []
      for (let i of list) {
        importlist.push({
          Barcode: i.Barcode,
          Qty: 0,
          Cost: 0,
          Sellingprice: i.NewPrice
        })
      }
      this.ItemList = [];
      var IdItemType: any = {
        Id: this.ds.Settings.ItemTypeId,
        Barcode: "",
        SellingPrice: this.ds.Settings.SellingPriceLevelId,
        Branch: this.ds.Settings.BranchId,
        Location: this.ds.Settings.LocationId,
        excelitems: importlist
      }
      this.pds.Get_Importpromotionitemsfromexcel(IdItemType).subscribe(res => {
        if (res.Success) {
          for (let i of res.data) {
            this.ItemList.push(i)
          }
          this.onImportComplete.emit({
            r: Math.random(),
            data: this.ItemList,
          });
          this.loading = true;
          var a: any = document.getElementById("ImptPromotion")
          a.value = ""
          this.loading = false
        }
        else {
          alert(res.error.UserMsg)
          this.loading = false;
        }
      });
    }
    this.loading = false
    this.reader.readAsArrayBuffer(file);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/import/import.component.ts